<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.${$constant.table.STAFF_KEY.role}`]="{ item }">
                <div
                    class="d-inline-flex role-item font-weight-bold px-2 py-1 rounded">
                    {{ item[$constant.table.STAFF_KEY.role] }}
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'

export default {
    name: 'StaffTable',

    components: {
        BaseTable
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('staffList.table.header.id'),
                    value: this.$constant.table.STAFF_KEY.id,
                    width: '140px',
                    sortable: false
                },
                {
                    text: this.$t('staffList.table.header.name'),
                    value: this.$constant.table.STAFF_KEY.name,
                    width: '180px',
                    sortable: false
                },
                {
                    text: this.$t('staffList.table.header.role'),
                    value: this.$constant.table.STAFF_KEY.role,
                    align: 'right',
                    sortable: false
                },
                {
                    text: '',
                    value: 'action',
                    width: '60px',
                    sortable: false
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.role-item {
    border: 1.8px solid #AEC7FD;
    background-color: #F0F5FF;
    color: #3E63E8;
}
</style>
